import { render } from "./SectionWithBg.vue?vue&type=template&id=37092384"
import script from "./SectionWithBg.vue?vue&type=script&lang=js"
export * from "./SectionWithBg.vue?vue&type=script&lang=js"

import "./SectionWithBg.vue?vue&type=style&index=0&id=37092384&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__